import { APIClient } from "./apiCore";
import * as url from "./urls";
import { ProfileTypes } from "../data";
const api = new APIClient();

const createEmailTemplate = (payload: any) => {
  const response: Promise<any> = api.create(url.CREATE_EMAIL_TEMPLATE, payload);
  return response;
};

const getAllEmailTemplates = () => {
  const response: Promise<any> = api.get(url.GET_ALL_EMAIL_TEMPLATES);
  return response;
};

const getEmailTemplate = (params: { templateId: string | undefined }) => {
  const response: Promise<any> = api.get(url.GET_EMAIL_TEMPLATE, params);
  return response;
};

const updateEmailTemplate = (payload: any) => {
  const response: Promise<any> = api.create(url.UPDATE_EMAIL_TEMPLATE, payload);
  return response;
};

const deleteEmailTemplate = (params: { templateId: string | undefined }) => {
  const response: Promise<any> = api.delete(url.DELETE_EMAIL_TEMPLATE, params);
  return response;
};

export {
  createEmailTemplate,
  getAllEmailTemplates,
  getEmailTemplate,
  updateEmailTemplate,
  deleteEmailTemplate,
};
